<template>
  <div>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5>
            <p class="table_card__head--title">Mensajes de Whatsapp</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                class="breadcums__option"
                @click="$router.push({ name: 'massive_whatsapp' })"
              >
                Historial de mensajes
              </v-breadcrumbs-item>
              <v-breadcrumbs-item class="breadcums__option" disabled>
                Nuevo mensaje
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <button
              type="button"
              class="faccess_button px-5"
              @click="sendMessage()"
              :disabled="isSendDisabled"
            >
              Enviar
            </button>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12>
            <v-form
              onSubmit="return false;"
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-layout row wrap class="white pa-3 rounded">
                <v-flex xs12 md6>
                  <span
                    class="table_card__info--label font-weight-bold"
                    style="display: block; margin-bottom: 8px;"
                  >
                    Plantilla
                  </span>
                  <v-select
                    label="Selecciona una plantilla"
                    :items="templates"
                    item-text="name"
                    item-value="value"
                    v-model="message.attributes.template_id"
                    single-line
                    bottom
                    color="#1476FB"
                    no-data-text="No hay plantillas disponibles"
                    solo
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout
                v-if="message.attributes.template_id != ''"
                row
                wrap
                style="margin-top: 16px;"
              >
                <v-flex xs12 md5 style="padding: 12px;">
                  <div style="margin-bottom: 8px;">
                    <span
                      class="font-weight-bold subheading grey--text text--darken-2"
                    >
                      Adjuntar información (Formato Excel)
                    </span>
                    <p>Debe contener campos de nombre, cédula, celular</p>
                  </div>

                  <v-layout row align-center style="margin-top: 12px;">
                    <v-btn
                      color="#1476FB"
                      class="white--text text-none px-4"
                      style="border-radius: 20px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"
                      :disabled="message.attributes.template_id == ''"
                      @click="$refs.excelInput.click()"
                    >
                      Añadir Archivo Excel
                    </v-btn>
                    <input
                      ref="excelInput"
                      type="file"
                      style="display: none;"
                      @change="excelUpload()"
                      name="logo"
                      accept=".xlsx, .xls, .csv"
                    />
                  </v-layout>

                  <v-card
                    v-if="excelTitle.length != 0"
                    flat
                    color="grey lighten-4"
                    style="margin-top: 16px; padding: 12px; border-radius: 8px; border: 1px solid #e0e0e0;"
                  >
                    <v-layout row align-center>
                      <img
                        style="width:28px; margin-right: 12px;"
                        src="https://karrottsportlife.s3-us-west-2.amazonaws.com/excel.png"
                        alt="Excel"
                      />
                      <div>
                        <p class="caption grey--text" style="margin-bottom: 0;">
                          Archivo cargado:
                        </p>
                        <p
                          class="body-2 font-weight-bold"
                          style="margin-bottom: 0;"
                        >
                          {{ excelTitle }}
                        </p>
                      </div>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex md1 class="hidden-sm-and-down"></v-flex>

                <v-flex xs12 md6 style="padding: 12px;">
                  <div style="margin-bottom: 8px;">
                    <span
                      class="font-weight-bold subheading grey--text text--darken-2"
                    >
                      Vista previa del mensaje
                    </span>
                  </div>

                  <v-card
                    v-if="templatePreview"
                    class="elevation-2"
                    style="padding: 16px; margin-top: 8px; border-radius: 8px;"
                  >
                    <div
                      class="body-1"
                      style="white-space: pre-wrap; line-height: 1.6;"
                      v-text="templatePreview"
                    ></div>

                    <v-divider
                      style="margin-top: 16px; margin-bottom: 8px;"
                    ></v-divider>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout row wrap style="margin-top: 24px;">
                <v-flex xs12>
                  <div v-if="tableData.length > 0">
                    <p style="margin-bottom: 4px;">
                      Los celulares no deben contener indicativo de país
                    </p>
                    <v-data-table
                      :headers="headers"
                      :items="tableData"
                      hide-actions
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <tr class="importers__user_row">
                          <td
                            v-for="(value, key) in props.item"
                            :key="key"
                            style="cursor: pointer;"
                            class="importers__user_data"
                          >
                            <input
                              v-model="props.item[key]"
                              :placeholder="key"
                              class="importers__input_data"
                              style="width: 100%; border: none; background: transparent;"
                            />
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
              <v-snackbar
                v-model="snackbar.show"
                :color="snackbar.color"
                :multi-line="snackbar.mode === 'multi-line'"
                :timeout="snackbar.timeout"
                :vertical="snackbar.mode === 'vertical'"
                style="margin-bottom: 16px;"
              >
                {{ snackbar.text }}
                <v-btn dark flat @click="snackbar.show = false">
                  Cerrar
                </v-btn>
              </v-snackbar>
            </v-form>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          type="button"
          class="faccess_button px-5"
          @click="sendMessage()"
          :disabled="isSendDisabled"
        >
          Enviar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      templates: [
        {
          name: "Anuncio de notificaciones vehiculares",
          value: "vehicle_notifications_update"
        },
        {
          name: "Anuncio de mantenimiento del sistema",
          value: "app_maintenance"
        },
        {
          name: "Anuncio de optimización en la app",
          value: "app_optimization_announcement"
        },
        {
          name: "Suspensión de servicio",
          value: "service_suspension"
        },
        {
          name: "Advertencia de suspensión de servicio",
          value: "service_suspension_warning"
        },
        {
          name: "Intermitencia de energía y/o conexión a internet en la zona",
          value: "energy_intermittence"
        },
        {
          name: "Actualización de aplicación",
          value: "app_update"
        },
        {
          name: "Actualización en sistema zona vehicular",
          value: "vehicular_system_update"
        },
        {
          name: "Asistencia capacitación",
          value: "training_assistance"
        },
        {
          name: "Visita para solución de novedad",
          value: "building_visit"
        },
        {
          name: "Mantenimiento preventivo en edificio",
          value: "preventive_maintenance"
        },
        { name: "Capsula de seguridad uno", value: "security_capsule_one" },
        { name: "Capsula de seguridad dos", value: "security_capsule_two" },
        {
          name: "Anuncio de instalación de equipos",
          value: "equipment_installation"
        },
        {
          name: "Anuncio levantamiento de información",
          value: "information_gathering"
        },
        {
          name: "Recordatorio de pago pendiente",
          value: "building_payment_pending"
        },
        {
          name: "Recordatorio pago del servicio",
          value: "service_payment_pending"
        }
      ],
      templatePreview: "",
      previewsCache: new Map(),
      snackbar: {
        show: false,
        y: "top",
        x: null,
        mode: "",
        timeout: 6000,
        color: "#0f9914",
        text: ""
      },
      message: {
        attributes: {
          title: "",
          message: "",
          users: [],
          company_id: 0,
          template_id: ""
        }
      },
      excelTitle: "",
      tableData: [],
      messageData: [],
      headers: [],
      valid: false
    };
  },
  mounted() {
    this.message.attributes.company_id = this.getCompany().id;
  },
  computed: {
    isSendDisabled() {
      return (
        !this.message.attributes.template_id ||
        !this.excelTitle ||
        this.messageData.length === 0
      );
    }
  },
  methods: {
    async excelUpload() {
      const file = this.$refs.excelInput.files[0];

      if (!file) return;

      const allowedExtensions = /\.(xls|xlsx|csv)$/i;

      if (!allowedExtensions.test(file.name)) {
        this.showSnackbar(
          "Por favor subir un archivo de códigos válido (Formato Excel o CSV)",
          "error"
        );
        return;
      }

      if (!window.FileReader) {
        this.showSnackbar("Este navegador no soporta HTML5", "error");
        return;
      }

      this.tableData = [];
      this.headers = [];
      this.messageData = [];
      this.message.attributes.users = [];
      this.excelTitle = "";

      try {
        const data = await this.readFile(file);
        const processed = this.processExcel(data);

        if (processed) {
          this.excelTitle = file.name;
        } else {
          this.cleanUpExcelData();
        }
      } catch (error) {
        this.showSnackbar(
          "Error al leer el archivo. Por favor intente de nuevo.",
          "error"
        );
        console.error("Excel upload error:", error);
      }
    },

    readFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = () => reject(reader.error);

        if (reader.readAsBinaryString) {
          reader.readAsBinaryString(file);
        } else {
          // IE fallback
          reader.onload = e => {
            const bytes = new Uint8Array(e.target.result);
            const data = Array.from(bytes, b => String.fromCharCode(b)).join(
              ""
            );
            resolve(data);
          };
          reader.readAsArrayBuffer(file);
        }
      });
    },
    processExcel(data) {
      const REQUIRED_HEADERS = ["nombre", "cedula", "celular"];

      // Read the Excel file
      const workbook = XLSX.read(data, { type: "binary" });

      // get first sheet name
      const firstSheet = workbook.SheetNames[0];

      // convert sheet to  JSON.
      const excelRowsJson = XLSX.utils.sheet_to_json(
        workbook.Sheets[firstSheet],
        {
          header: 1
        }
      );

      if (excelRowsJson.length <= 0) {
        this.showSnackbar(
          "El archivo no contiene datos. Por favor verifique el contenido.",
          "error"
        );
        return false;
      }

      // Normalize headers removing spaces, accents, emojis and making everything lowercase
      const normalizeHeader = header => {
        if (!header) return "columna_sin_nombre";
        return header
          .toString()
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-z0-9]+/g, "_")
          .replace(/^_+|_+$/g, "");
      };
      // headers are at row 0.
      const headers = excelRowsJson[0].map(normalizeHeader);

      const missingHeaders = REQUIRED_HEADERS.filter(h => !headers.includes(h));

      if (missingHeaders.length > 0) {
        this.showSnackbar(
          `El archivo es inválido.\n` +
            `La primera fila debe contener los encabezados.\n` +
            `Faltan: ${missingHeaders.join(", ")}`,
          "error"
        );
        return false;
      }
      // data start at row 1.
      for (let i = 1; i < excelRowsJson.length; i++) {
        const rowData = excelRowsJson[i];

        // Check that row has data
        if (
          Array.isArray(rowData) &&
          rowData.some(cell => cell !== null && cell !== "")
        ) {
          const dataObject = {};

          for (let j = 0; j < headers.length; j++) {
            const header = headers[j];
            dataObject[header] = rowData[j];
          }

          this.tableData.push(dataObject);
        }
      }

      // Add headers for the table
      for (let x = 0; x < headers.length; x++) {
        const data = {
          text: headers[x],
          align: "left",
          sortable: false,
          value: headers[x]
        };

        this.headers.push(data);
      }

      this.buildMessageData();

      return true;
    },
    cleanUpExcelData() {
      this.tableData = [];
      this.headers = [];
      this.messageData = [];
      this.message.attributes.users = [];
      this.excelTitle = "";
      if (this.$refs.excelInput) {
        this.$refs.excelInput.value = null;
      }
    },
    buildMessageData() {
      this.messageData = [];
      this.message.attributes.users = [];

      this.tableData.forEach(data => {
        if (!data["celular"]) {
          return;
        }

        const message_data = {};
        this.message.attributes.users.push(data.celular);

        message_data["mobile"] = data["celular"].toString();

        if (data["link"]) {
          message_data["link"] = data["link"].toString();
        }

        this.messageData.push(message_data);
      });
    },
    showSnackbar(message, type = "success") {
      this.snackbar.text = message;
      // show red for errors, green for success
      this.snackbar.color = type === "error" ? "#f44336" : "#0f9914";
      // show longer timeout for errors, default for success
      this.snackbar.timeout = type === "error" ? 8000 : 6000;
      this.snackbar.show = true;
    },
    sendMessage() {
      // Rebuild message data to include any edits made in the table
      this.buildMessageData();

      if (!this.message.attributes.template_id) {
        this.showSnackbar(
          "Debe seleccionar una plantilla antes de enviar el mensaje.",
          "error"
        );
        return;
      }

      if (!this.messageData.length) {
        this.showSnackbar(
          "No hay destinatarios válidos para enviar el mensaje.",
          "error"
        );
        return;
      }

      this.message.attributes.message = this.templatePreview;
      const data = { message_info: this.message, receivers: this.messageData };
      this.$http
        .post(
          "push_messages/send_massive_whatsapp_messages",
          {
            data: this.encrypt(data).toString()
          },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          }
        )
        .then(response => {
          this.showSnackbar(response.body.ans, "success");
          this.$router.push({ name: "massive_whatsapp" });
          this.updateAuthToken(response.body.meta);
        })
        .catch(response => {
          this.showSnackbar(
            "Ocurrió un error al enviar el mensaje. Por favor intente de nuevo.",
            "error"
          );
          this.updateAuthToken(response.body.meta);
        });
    },
    updateAuthToken(meta) {
      if (
        !meta ||
        meta.authentication_token === undefined ||
        meta.authentication_token === null
      ) {
        return;
      }

      this.checkToken(meta.authentication_token);
    }
  },
  watch: {
    // if the table data is edited, rebuild the message data
    tableData: {
      handler() {
        this.buildMessageData();
      },
      deep: true
    },
    "message.attributes.template_id": function(newValue) {
      if (!newValue) return;

      if (this.previewsCache.has(newValue)) {
        this.templatePreview = this.previewsCache.get(newValue);
        return;
      }

      const template = this.templates.find(t => t.value === newValue);
      if (!template) return;
      const templateName = template.name;

      this.message.attributes.title = templateName;

      this.$http
        .get("whatsapp_templates/" + newValue, {
          headers: {
            "X-Device-ID": this.getDeviceId(),
            Authorization: "Bearer " + this.getUserToken()
          }
        })
        .then(response => {
          this.templatePreview = response.body.structure.body.text;
          this.previewsCache.set(newValue, response.body.structure.body.text);
        })
        .catch(() => {
          this.templatePreview = "";
          this.showSnackbar(
            "No se pudo cargar la plantilla seleccionada. Por favor intente nuevamente.",
            "error"
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/whatsapp/new_message.vue